import axios from 'axios'
import { Post, Get } from "../server";

// 登录
export const login = (params: any) => {
  return axios({
    url: `/admin/auth/login`,
    method: "post",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("come-to-chant-token"),
    },
    data: params,
    baseURL: process.env.REACT_APP_BASE_URL,
  });
};

// 修改密码
export const changePassword = (params: any) => {
  return axios({
    url: `/admin/auth/password`,
    method: "put",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("come-to-chant-token"),
    },
    data: params,
    baseURL: process.env.REACT_APP_BASE_URL,
  });
}

export const getAllAuthorities = (userId: any) => {
  return axios({
    url: `/admin/auth/authorities/${userId}`,
    method: "get",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("come-to-chant-token"),
    },
    baseURL: process.env.REACT_APP_BASE_URL,
  });
}